module.exports = require("./bem.d.ts");